'use client'
const zeroAddress = '0x0000000000000000000000000000000000000000';
const nativeSolanaAddress = '11111111111111111111111111111111';

export { nativeSolanaAddress, zeroAddress };
